var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.addEmailTitle || _vm.$t("添加收件人邮箱"),
      visible: _vm.addEmailVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 600
    },
    on: {
      ok: _vm.handleSure,
      cancel: _vm.cancelAdd
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("示例") + "：carlyxxxxxxx@126.com" + _vm.$t("添加多个账号以英文‘,’（英文）进行分隔")))]), _c("a-textarea", {
    staticClass: "email-box",
    model: {
      value: _vm.emails,
      callback: function ($$v) {
        _vm.emails = $$v;
      },
      expression: "emails"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };